import WavingHandIcon from '@mui/icons-material/WavingHand';
import { Tooltip, Typography } from '@mui/material';

import UserRoles from '@/dmdrive/topic/components/UserRoles/UserRoles';
import { TopicUser } from '@/dmdrive/topic/entities/TopicUser';

import {
  ParticipantHeading,
  ParticipantName,
  ParticipantRoles,
  ParticipantRowDescription,
  ParticipantRowRoot,
} from './ParticipantRow.styles';

import ParticipantActions from './ParticipantActions/ParticipantActions';

interface ParticipantRowProps {
  participant: TopicUser;
}

function ParticipantRow(props: ParticipantRowProps) {
  const { participant } = props;

  return (
    <ParticipantRowRoot>
      <ParticipantRowDescription>
        <ParticipantHeading>
          {participant.requestMaster && (
            <Tooltip title="Requesting for master">
              <WavingHandIcon color="warning" />
            </Tooltip>
          )}

          <ParticipantName>
            <Typography>
              <span>{participant.username}</span>

              {participant.isMe && <span> (me)</span>}
            </Typography>
          </ParticipantName>

          <ParticipantActions isMe={participant.isMe} participant={participant} />
        </ParticipantHeading>

        <ParticipantRoles>
          <UserRoles user={participant} />

          <Typography variant="caption">{participant.email}</Typography>
        </ParticipantRoles>
      </ParticipantRowDescription>
    </ParticipantRowRoot>
  );
}

export default ParticipantRow;
